<div class="app-shell" [class.sidebar-collapsed]="sidebarCollapsed()">

  <!-- Skip link for accessibility -->
  <a class="skip-link" href="#main-content">Ir para o conteúdo principal</a>

  <!-- Topbar fixa (largura total) -->
  <header class="shell-header" role="banner">
    <app-topbar
      [sidebarCollapsed]="sidebarCollapsed()"
      (toggleSidebar)="toggleSidebar()"
      (openMobileDrawer)="openMobileDrawer()">
    </app-topbar>
  </header>

  <div class="shell-body">

    <!-- Sidebar — desktop -->
    <aside class="shell-sidebar" aria-label="Navegação principal">
      <app-sidebar [collapsed]="sidebarCollapsed()" (itemSelected)="closeMobileDrawer()"></app-sidebar>
    </aside>

    <!-- Backdrop mobile -->
    @if (mobileDrawerOpen()) {
      <div
        class="mobile-backdrop"
        aria-label="Fechar menu lateral"
        role="button"
        tabindex="0"
        (click)="closeMobileDrawer()"
        (keydown.escape)="closeMobileDrawer()">
      </div>
    }

    <!-- Drawer mobile -->
    <aside
      class="shell-drawer"
      [class.open]="mobileDrawerOpen()"
      aria-label="Menu de navegação mobile">
      <app-sidebar [collapsed]="false" (itemSelected)="closeMobileDrawer()"></app-sidebar>
    </aside>

    <!-- Canvas de conteúdo -->
    <main id="main-content" class="shell-canvas" role="main">
      <router-outlet></router-outlet>
    </main>

  </div>

</div>
